/* eslint-disable */
import React, { Fragment, PureComponent } from 'react';
import {
    Button, message, Table, Card, Row, Col, Checkbox, Skeleton, Tabs, Divider, Tag, DatePicker, Form
} from 'antd'
import moment from 'moment'

// Now API
import {
    flight_multiple_searching_api_response,
    flight_multiple_searching_db_api_response
} from '../../helper/api_v1/flight_search'

import ExcelExport from './../../utils/xlsx'

export default class ComMultipleSearching extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            btnLoading: false,
            dbbtnLoading: false,
            setPinCode: "",
            origin: props.origin,
            destination: props.destination,
            end_time: props.end_time,
            classes: props.classes,
            dataSource: [],
            db_dataSource: [],
            flightCode: [],
            columns: [
                {
                    title: 'Search Date',
                    dataIndex: 'search_data',
                    key: 'search_date',
                    align: "center",
                    width: 100,
                },
                {
                    title: 'Route',
                    dataIndex: 'route',
                    key: 'route',
                    align: "center",
                    width: 100,
                },
                {
                    title: 'Airline Code',
                    dataIndex: 'airline_code',
                    key: 'airline_code',
                    align: "center",
                    width: 100,
                },
                {
                    title: 'Travel Date',
                    dataIndex: 'travel_date',
                    key: 'travel_date',
                    align: "center",
                    width: 100,
                },
                {
                    title: 'FE B2C',
                    dataIndex: 'fe_b2c',
                    key: 'fe_b2c',
                    align: "center",
                    width: 100,
                    render: (text, row) => {
                        let min = false
                        if (Number(row.fe_b2c) <= Number(row.st_b2c)) {
                            min = true
                        }
                        return (
                            <Fragment>
                                {min ? <Tag color="green">{text}</Tag> : text}
                            </Fragment>
                        )
                    }
                },
                {
                    title: 'Share Trip B2C',
                    dataIndex: 'st_b2c',
                    key: 'st_b2c',
                    align: "center",
                    width: 100,
                    render: (text, row) => {
                        let min = false
                        if (Number(row.fe_b2c) >= Number(row.st_b2c)) {
                            min = true
                        }
                        return (
                            <Fragment>
                                {min ? <Tag color="green">{text}</Tag> : text}
                            </Fragment>
                        )
                    }
                },
                {
                    title: 'FE B2B',
                    dataIndex: 'fe_b2b',
                    key: 'fe_b2b',
                    align: "center",
                    width: 100,
                    render: (text, row) => {
                        let min = false
                        if (Number(row.fe_b2b) <= Number(row.st_b2b)) {
                            min = true
                        }
                        return (
                            <Fragment>
                                {min ? <Tag color="green">{text}</Tag> : text}
                            </Fragment>
                        )
                    }
                },
                {
                    title: 'Share Trip B2B',
                    dataIndex: 'st_b2b',
                    key: 'st_b2b',
                    align: "center",
                    width: 100,
                    render: (text, row) => {
                        let min = false
                        if (Number(row.fe_b2b) >= Number(row.st_b2b)) {
                            min = true
                        }
                        return (
                            <Fragment>
                                {min ? <Tag color="green">{text}</Tag> : text}
                            </Fragment>
                        )
                    }
                },
            ]
        }
    }


    func_multiple_flight_search = async () => {

        let flightMultiple = [];
        this.setState({ dataSource: [], btnLoading: true })

        let {
            origin,
            destination,
            end_time,
            flightCode
        } = this.state

        origin = this.props.origin
        destination = this.props.destination
        end_time = this.props.end_time

        if (origin !== "" && destination !== "" && end_time !== "" && flightCode.length !== 0) {

            message.destroy()
            message.loading("Please Wait...", 0)
            flightMultiple = await flight_multiple_searching_api_response({
                origin,
                destination,
                depDate: end_time,
                flightCode: flightCode
            })
            message.destroy()
            message.destroy()
            message.destroy()

        } else {

            message.destroy()
            message.warn("Check origin, destination, destination date or flight source")
            flightMultiple = []

        }

        if (Array.isArray(flightMultiple) && flightMultiple.length !== 0) {
            message.warn("Data Not Found")
        }

        this.setState({ dataSource: flightMultiple, btnLoading: false })
    }


    db_Store_func_multiple_flight_search = async ({ prams }) => {

        this.setState({ db_dataSource: [], dbbtnLoading: true })

        message.loading('Please Wait...', 0)
        let flightMultipleDB = await flight_multiple_searching_db_api_response({ prams })
        flightMultipleDB = flightMultipleDB.search_result

        message.destroy()
        message.destroy()
        message.destroy()

        this.setState({ db_dataSource: flightMultipleDB, dbbtnLoading: false })
    }


    // NOTE Excel Export Print
    excelExportPrint = (dataSource, type) => {
        if (type === "nonDB") {
            let data = []
            dataSource.map(item => {
                return data.push({
                    "Search Date": item.search_data,
                    "Route": item.route,
                    "Airline Code": item.airline_code,
                    "Travel Date": item.travel_date,
                    "FE B2C": item.fe_b2c,
                    "Share Trip B2C": item.st_b2c,
                    "FE B2B": item.fe_b2b,
                    "Share Trip B2B": item.st_b2b
                })
            })
            ExcelExport(data, `Report ${moment().format('DD/MM/YYYYY')}`)
        }
        if (type === "DB") {
            let data = []
            dataSource.map(item => {
                data.push({
                    "Searching Data": item.search_data,
                })
                item.data.map(i => {
                    data.push({
                        "Search Date": i.search_data,
                        "Route": i.route,
                        "Airline Code": i.airline_code,
                        "Travel Date": i.travel_date,
                        "FE B2C": i.fe_b2c,
                        "Share Trip B2C": i.st_b2c,
                        "FE B2B": i.fe_b2b,
                        "Share Trip B2B": i.st_b2b
                    })
                })
                data.push({ "": "" })
                data.push({ "": "" })
            })
            ExcelExport(data, `Report ${moment().format('DD/MM/YYYYY')}`)
        }
    }

    render() {
        const {
            dataSource,
            db_dataSource,
            btnLoading,
            dbbtnLoading,
            columns,
        } = this.state

        return (
            <Fragment>
                <Card
                    title={"Flight Code"}
                    bordered={false}
                >
                    <Checkbox.Group style={{ width: '100%' }} onChange={(e) => this.setState({ flightCode: e })}>
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={6}>
                                <Checkbox value="BG">BG (Biman Bangladesh Airlines )</Checkbox>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={6}>
                                <Checkbox value="VQ">VQ (NOVOAIR)</Checkbox>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={6}>
                                <Checkbox value="BS">BS (US-Bangla Airlines)</Checkbox>
                            </Col>
                        </Row>
                    </Checkbox.Group>
                </Card>

                <Tabs >
                    {/* NOTE Tab 1 */}
                    <Tabs.TabPane tab="Multiple Search" key="1">
                        <Card
                            bordered={false}
                            title={"Search"}
                            extra={
                                <Fragment>
                                    <Button
                                        hidden={dataSource.length === 0}
                                        type="primary"
                                        onClick={() => {
                                            this.excelExportPrint(this.state.dataSource, "nonDB")
                                        }}
                                    >Export</Button>
                                    <Divider type="vertical" />
                                    <Button
                                        loading={btnLoading}
                                        type="primary"
                                        onClick={this.func_multiple_flight_search}
                                    >Search</Button>
                                </Fragment>
                            }
                        >
                            <Skeleton loading={btnLoading} />
                            {
                                dataSource.length !== 0 &&
                                <Fragment>
                                    <Table
                                        rowKey="rowId"
                                        style={{ width: 'auto', margin: 2 }}
                                        size="small"
                                        dataSource={dataSource}
                                        total={dataSource.length}
                                        pagination={false}
                                        scroll={{ x: "max-content" }}
                                        columns={columns}

                                    />
                                </Fragment>
                            }
                        </Card>
                    </Tabs.TabPane>

                    {/* NOTE Tab 2 */}
                    <Tabs.TabPane tab="Database Record Search" key="2">
                        <Card
                            bordered={false}
                            title={"Search"}
                            extra={
                                <Fragment>
                                    <Button
                                        hidden={db_dataSource.length === 0}
                                        type="primary"
                                        onClick={() => {
                                            this.excelExportPrint(this.state.db_dataSource, "DB")
                                        }}
                                    >Export</Button>
                                    <Divider type="vertical" />
                                    <Button
                                        loading={btnLoading}
                                        type="primary"
                                        onClick={this.db_Store_func_multiple_flight_search}
                                    >Search</Button>
                                </Fragment>
                            }
                        >
                            <Form layout="vertical">
                                <Form.Item label="Travel Date">
                                    <DatePicker
                                        style={{width: 200}}
                                        placeholder="Search Travel Date"
                                        onChange={(e, date) => 
                                            this.db_Store_func_multiple_flight_search({ prams: date })
                                        }
                                    />
                                </Form.Item>
                            </Form>
                            <Divider />
                            <Skeleton loading={dbbtnLoading} />
                            {
                                db_dataSource.length !== 0 &&
                                <Fragment>

                                    {
                                        db_dataSource.map(i =>
                                            <Fragment>
                                                <div style={{ marginTop: 20, marginBottom: 20 }}>
                                                    <Divider style={{ color: 'blue' }}> 
                                                        Searching Date: {i.search_data} <br/> Travel Date: {i.travel_date}
                                                        
                                                    </Divider>
                                                    <Table
                                                        rowKey="rowId"
                                                        style={{ width: 'auto', margin: 2 }}
                                                        size="small"
                                                        dataSource={Array.isArray(i.data) ? i.data : []}
                                                        total={Array.isArray(i.data) ? i.data.length : 0}
                                                        pagination={false}
                                                        scroll={{ x: "max-content" }}
                                                        columns={columns}
                                                    />
                                                    <br/>
                                                </div>
                                            </Fragment>
                                        )
                                    }
                                </Fragment>
                            }
                        </Card>
                    </Tabs.TabPane>
                </Tabs>
            </Fragment>
        );
    }
}
